import React from 'react';
import PropTypes from 'prop-types';

import MuiCard from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';

import { useStyles, useHeaderStyles } from './styles';

const Card = ({ title, titleAction, children, actions, fullHeight }) => {
	const classes = useStyles({ title, fullHeight });
	const headerClasses = useHeaderStyles({ titleAction });

	return (
		<MuiCard elevation={1} className={classes.root}>
			{title && (
				<CardHeader
					title={<Typography variant="h6">{title}</Typography>}
					action={titleAction}
					classes={headerClasses}
				/>
			)}

			<CardContent className={classes.content}>{children}</CardContent>

			{actions && <CardActions className={classes.actions}>{actions}</CardActions>}
		</MuiCard>
	);
};

Card.propTypes = {
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	titleAction: PropTypes.node,
	children: PropTypes.node.isRequired,
	actions: PropTypes.node,
	fullHeight: PropTypes.bool
};

export default Card;
